import React, { useEffect, useRef } from 'react';
import './TestimonialsPage.css';
import { Star, Quote } from 'lucide-react';
import profilepic from '../assets/Siew Ling.jpg';
import profilepic2 from '../assets/Sherman.jpeg';

const TestimonialsPage = () => {
  const testimonials = [
    {
      id: 1,
      text: "MyWave has been using IM Talent and Financial Analytic since 2023, especially retention risk in talent analytics. As a HRMS solutions provider, we can confirm that it has at least 95% accuracy, as we have used it to manage potential resignation that we successfully retained. We also saw how the data was reflected after we responded and took appropriate actions to retain employees. I also rely on a lot to the finance analytics, especially each time when I have my board or investor meetings. The insights and presentation of the data helps me understand the situation better and allows me to present the facts to my shareholders and investors with credibility as well as a providing solutions to the situations. I highly recommend these analytics tools to business owners or managers.",
      author: "Khoo Siew Ling",
      position: "MyWave CEO",
      rating: 5,
      image: profilepic
    },
    {
      id: 2,
      text: "Collaborating with Intematics has been a transformative experience for our internal stakeholders. Their agile, adaptive, and business-savvy team consistently demonstrates that nothing is impossible. They are not just partners, but an integral part of our data journey, driving innovation and success every step of the way.",
      author: "Sherman See",
      position: "Frencken VP of Operations Excellence",
      rating: 5,
      image: profilepic2
    },
  ];

  const headerRef = useRef(null);
  const cardsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.2 }
    );

    // Store ref.current values to avoid stale references in cleanup
    const headerEl = headerRef.current;
    const cardsEl = cardsRef.current;

    if (headerEl) observer.observe(headerEl);
    if (cardsEl) observer.observe(cardsEl);

    return () => {
      if (headerEl) observer.unobserve(headerEl);
      if (cardsEl) observer.unobserve(cardsEl);
    };
  }, []);

  const renderStars = (rating) => {
    return Array(5)
      .fill(0)
      .map((_, index) => (
        <Star 
          key={index}
          size={16}
          className={index < rating ? "star filled" : "star"}
          aria-label={index < rating ? "Filled star" : "Empty star"}
        />
      ));
  };

  return (
    <div className="testimonials-page">
      <div className="testimonials-container">
        <div className="testimonials-header" ref={headerRef}>
          <h1>Testimonials</h1>
          <p>
            <span className="brand-name-testi">See what our clients have to say about working with us and using our products.</span>
            We're committed to delivering solutions that drive real results, 
            and our clients' feedback reflects the impact we've made.
          </p>
        </div>
        
        <div className="testimonials-cards-container" ref={cardsRef}>
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id} 
              className="testimonial-card"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="quote-icon">
                <Quote size={32} aria-hidden="true" />
              </div>
              <div className="testimonial-content">
                <p className="testimonial-text">{testimonial.text}</p>
                <div className="testimonial-rating">
                  {renderStars(testimonial.rating)}
                </div>
              </div>
              <div className="testimonial-author">
                <img 
                  src={testimonial.image} 
                  alt={`Portrait of ${testimonial.author}`} 
                  className="author-image" 
                />
                <div className="author-details">
                  <h3>{testimonial.author}</h3>
                  <p>{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsPage;